export * from './lib/registry';
export * from './lib/svg-icons.module';
